<template>
  <div class="flex flex-col h-screen pb-safe overflow-hidden">
    <home-top-bar show-back @back="router.back()">
      <template #center>
        <div class="heading-3">
          {{ t('sidemenu.orders-overview') }}
        </div>
      </template>
    </home-top-bar>
    <tab-browser tabs-type="all" class="flex-1 min-h-0" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import HomeTopBar from '@/components/HomeTopBar.vue'

import TabBrowser from './TabBrowser.vue'

const { t } = useI18n()
const router = useRouter()
</script>
